import React from 'react';
import PropTypes from 'prop-types';
import './SellerDashboard.scss';

const formatMoney = (amount) => Number(amount || 0).toLocaleString('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 2,
});

const SellerDashboard = ({ error, generatingCode, loading, onGenerateCode, summary }) => {
  if (loading) return <main className="seller-dashboard">Cargando panel…</main>;

  return (
    <main className="seller-dashboard container">
      <h1>Panel de vendedor</h1>
      {error && <p className="seller-dashboard__error" role="alert">{error}</p>}

      {summary && (
        <>
          <section className="seller-dashboard__link">
            <h2>Tu enlace de referencia</h2>
            {summary.referral_url ? (
              <>
                <strong>{summary.ref_code}</strong>
                <a href={summary.referral_url}>{summary.referral_url}</a>
              </>
            ) : (
              <button type="button" disabled={generatingCode} onClick={onGenerateCode}>
                {generatingCode ? 'Generando…' : 'Generar código'}
              </button>
            )}
          </section>

          <section className="seller-dashboard__metrics" aria-label="Resumen de ventas">
            <article><span>Clientes referidos</span><strong>{summary.referred_customers_count || 0}</strong></article>
            <article><span>Ventas pagadas</span><strong>{summary.paid_sales_count || 0}</strong></article>
            <article><span>Ventas pendientes</span><strong>{summary.non_paid_sales_count || 0}</strong></article>
            <article><span>Total vendido</span><strong>{formatMoney(summary.paid_total)}</strong></article>
          </section>
        </>
      )}
    </main>
  );
};

SellerDashboard.propTypes = {
  error: PropTypes.string.isRequired,
  generatingCode: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onGenerateCode: PropTypes.func.isRequired,
  summary: PropTypes.shape(),
};

SellerDashboard.defaultProps = { summary: null };

export default SellerDashboard;
